import { useCallback } from 'react';
import { Modal, StyledFlex } from '@tryhackme/thm-ui-components';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImageGlitch from 'src/images/svgs/christmas/glitch-pop-up.svg';
import { ReactComponent as XTwitterIcon } from 'src/images/svgs/socials/x-twitter.svg';
import { ReactComponent as FacebookIcon } from 'src/images/svgs/socials/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';
import { SegmentShareEvent } from 'src/common/types';
import { useTrackEventMutation } from 'src/common/slices';
import { generateSocialMediaShareLink, SocialName } from 'src/features/room/components/completion-modal';
import { facebookCampaignData, linkedinCampaignData, twitterCampaignData } from 'src/features/room/components/completion-modal/completion-modal.constants';
import { StyledSocialButton } from 'src/common/styles';
import { ShareAoCModalProps } from './share-aoc-modal.types';
import { StyledAdventText, StyledModalWrapper, StyledShareButton } from './share-aoc-modal.styles';
export const ShareAoCModal = ({
  roomCode,
  isShareAoCModalOpen,
  setIsShareAoCModalOpen,
  onOpenChange,
  ...otherModalProps
}: ShareAoCModalProps) => {
  const [trackEvent] = useTrackEventMutation();
  const trackShareChallengeClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'click-AoC-CTA',
      properties: {
        room_code: roomCode,
        type: 'room',
        name: roomCode,
        medium: source
      }
    });
    // eslint-disable-next-line no-void
    void trackEvent({
      event,
      properties: {
        room_code: roomCode
      }
    });
  }, [trackEvent, roomCode]);
  const christmasLink = 'https://tryhackme.com/r/christmas';
  return <Modal {...otherModalProps} onOpenChange={onOpenChange} open={isShareAoCModalOpen} preventOnOpenAutoFocus triggerElement={<StyledShareButton color="info">
          <FontAwesomeIcon icon={faShare} />
          Share the challenge
        </StyledShareButton>} padding="0" data-sentry-element="Modal" data-sentry-component="ShareAoCModal" data-sentry-source-file="share-aoc-modal.tsx">
      <StyledModalWrapper data-sentry-element="StyledModalWrapper" data-sentry-source-file="share-aoc-modal.tsx">
        <img src={ImageGlitch} alt="Share Advent of Cyber 2024" width="512" height="346" loading="lazy" />

        <h2>You&apos;re in… but can your friends crack it too?</h2>
        <StyledAdventText data-sentry-element="StyledAdventText" data-sentry-source-file="share-aoc-modal.tsx">
          Advent of Cyber <span>2024</span>
        </StyledAdventText>
        <p>Share this with your friends. Grab your share of $100,000 in prizes!</p>
        <StyledFlex justifyContent="center" data-sentry-element="StyledFlex" data-sentry-source-file="share-aoc-modal.tsx">
          <StyledSocialButton data-social="linkedin" href={generateSocialMediaShareLink(SocialName.LINKEDIN, roomCode, linkedinCampaignData, christmasLink)} target="_blank" onClick={() => trackShareChallengeClick('share-linkedin')} data-sentry-element="StyledSocialButton" data-sentry-source-file="share-aoc-modal.tsx">
            <LinkedinIcon data-sentry-element="LinkedinIcon" data-sentry-source-file="share-aoc-modal.tsx" />
            Linkedin
          </StyledSocialButton>
          <StyledSocialButton data-social="twitter-x" href={generateSocialMediaShareLink(SocialName.TWITTER, roomCode, twitterCampaignData, christmasLink)} target="_blank" onClick={() => trackShareChallengeClick('share-twitter')} data-sentry-element="StyledSocialButton" data-sentry-source-file="share-aoc-modal.tsx">
            <XTwitterIcon data-sentry-element="XTwitterIcon" data-sentry-source-file="share-aoc-modal.tsx" />
            Twitter / X
          </StyledSocialButton>
          <StyledSocialButton data-social="facebook" href={generateSocialMediaShareLink(SocialName.FACEBOOK, roomCode, facebookCampaignData, christmasLink)} target="_blank" onClick={() => trackShareChallengeClick('share-facebook')} data-sentry-element="StyledSocialButton" data-sentry-source-file="share-aoc-modal.tsx">
            <FacebookIcon data-sentry-element="FacebookIcon" data-sentry-source-file="share-aoc-modal.tsx" />
            Facebook
          </StyledSocialButton>
        </StyledFlex>
      </StyledModalWrapper>
    </Modal>;
};